import styled from 'styled-components';
import colors from '../../colorPalette';
const ActionButton = styled.button `
  border: 0;
  border-radius: 2px;
  background-color: ${colors.black};
  font-size: 14px;
  padding: 2px 8px;
  cursor: pointer;
`;
export default ActionButton;
